<template>
  <div ref="container" class="filter-chip-group">
    <template v-if="showingItems.length === filters.length">
      <template v-for="(filter, index) in showingItems">
        <z-chip
          :key="index"
          class="filter-chip"
          icon-right
          selected
          :icon="removeIcon"
          :text="filter.text"
          @click="onRemoveFilter(filter)"
        />
      </template>
    </template>

    <template v-else>
      <v-menu
        class="elevation-1"
        content-class="mt-2 filter-group-menu"
        bottom
        offset-y
      >
        <template #activator="{on}">
          <v-chip
            class="all-filters-chip"
            color="primary"
            tabindex="0"
            v-on="on"
          >
            <span> {{ firstItem.text }}... </span>
            <v-icon>{{ removeIcon }}</v-icon>
          </v-chip>
        </template>
        <z-card class="pa-4 elevation-1" width="100%">
          <template #content>
            <template v-for="(filter, index) of menuItems">
              <z-chip
                :key="index"
                class="filter-chip my-1"
                icon-right
                selected
                :icon="removeIcon"
                :text="filter.text"
                @click="onRemoveFilter(filter)"
              />
            </template>
          </template>
        </z-card>
      </v-menu>
      <template
        v-for="(filter, index) in showingItems.slice(1, showingItems.length)"
      >
        <z-chip
          :key="index"
          class="filter-chip"
          icon-right
          selected
          icon="$remove_circle_outline_rounded"
          :text="filter.text"
          @click="onRemoveFilter(filter)"
        />
      </template>
    </template>
  </div>
</template>

<script>
const PADDING_AND_ICON_WIDTH = 30

/**
 * @displayName Chips Filter Group
 */
export default {
  name: 'ZChipsFilterGroup',
  props: {
    /**
     * Array de filtros que serão renderizados pelo componente
     */
    filters: {
      type: Array,
      default: () => [],
    },
    /**
     * Define a cor dos chips do filtro
     */
    color: {
      type: String,
      default: null,
    },
    /**
     * Define o ícone de remoção do filtro
     */
    removeIcon: {
      type: String,
      default: '$remove_circle_outline_rounded',
    },
  },
  data() {
    return {
      availableWidth: 200,
    }
  },
  computed: {
    availableSpaceLeft() {
      let showingItemsWidth = 0

      for (let filter of this.filters) {
        const prevWidth = showingItemsWidth
        showingItemsWidth += filter.text.length * 8 + PADDING_AND_ICON_WIDTH

        if (showingItemsWidth > this.availableWidth) {
          return this.availableWidth - prevWidth
        }
      }
      return this.availableWidth
    },
    firstItem() {
      if (this.showingItems.length === 0) return

      const firstItem = {text: this.showingItems[0].text}
      const availableChars =
        firstItem.text.length + this.availableSpaceLeft / 8 - 8

      for (let menuItem of this.menuItems) {
        firstItem.text += ', '
        for (let i = 0; i < menuItem.text.length; ++i) {
          if (firstItem.text.length > availableChars) {
            return firstItem
          }
          firstItem.text += menuItem.text[i]
        }
      }

      return firstItem
    },
    menuItems() {
      return this.filters.filter((filter) => {
        return this.showingItems.every(
          (showingFilter) => showingFilter !== filter
        )
      })
    },
    showingItems() {
      const showingItems = []
      let showingItemsWidth = 0

      for (let filter of this.filters) {
        const filterStringWidth = filter.text.length

        showingItemsWidth += filterStringWidth * 8 + PADDING_AND_ICON_WIDTH

        if (showingItemsWidth > this.availableWidth) {
          break
        }
        showingItems.push(filter)
      }

      return showingItems
    },
  },
  mounted() {
    this.availableWidth = this.$refs.container.clientWidth
  },
  methods: {
    onRemoveFilter(filter) {
      /**
       * Emitido quando o icone de remover é clicado
       *
       * @property {Object} filter - O filtro que foi removido
       */
      this.$emit('remove', filter)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-chip-group {
  width: 100%;
  margin-right: 2px;
  margin-left: 2px;
}

.filter-group-menu {
  border-radius: var(--component-card-radius);
}

::v-deep,
.all-filters-chip {
  span {
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
